import { useEffect, useState } from 'react';
import { Trade } from '@/api/index.js';

export function useProfilePreviewTrades(
	previewUserId: string | undefined,
	user: any,
	lobby: any,
	currentUserTrades: any[]
) {
	const [userTrades, setUserTrades] = useState<any[]>([]);

	useEffect(() => {
		if (!previewUserId || previewUserId === user?.id) {
			setUserTrades(currentUserTrades);
			return;
		}

		let cancelled = false;

		const fetchTrades = async () => {
			const trades = user?.id
				? await Trade.filter({ user_id: previewUserId, lobby_id: lobby.id })
				: [];
			if (!cancelled) setUserTrades(trades);
		};

		fetchTrades();

		return () => {
			cancelled = true;
		};
	}, [previewUserId, lobby.id, currentUserTrades, user?.id]);

	return userTrades;
}
